module.exports = __webpack_public_path__ + "static/img/gx.d7cecf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service/gx.png
// module id = ClYh
// module chunks = 0